/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * The original details of a tool
 */
export type CanonicalToolAttributes = {
  /**
   * Confirmation mode for the tool
   */
  confirm?: string | undefined;
  /**
   * Prompt for the confirmation
   */
  confirmPrompt?: string | undefined;
  /**
   * Description of the tool
   */
  description: string;
  /**
   * The name of the tool
   */
  name: string;
  /**
   * Summarizer for the tool
   */
  summarizer?: string | undefined;
  /**
   * The ID of the variation that was applied to the tool
   */
  variationId: string;
};

/** @internal */
export const CanonicalToolAttributes$inboundSchema: z.ZodMiniType<
  CanonicalToolAttributes,
  unknown
> = z.pipe(
  z.object({
    confirm: z.optional(z.string()),
    confirm_prompt: z.optional(z.string()),
    description: z.string(),
    name: z.string(),
    summarizer: z.optional(z.string()),
    variation_id: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "confirm_prompt": "confirmPrompt",
      "variation_id": "variationId",
    });
  }),
);

export function canonicalToolAttributesFromJSON(
  jsonString: string,
): SafeParseResult<CanonicalToolAttributes, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CanonicalToolAttributes$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CanonicalToolAttributes' from JSON`,
  );
}
